import type { JSX } from 'react'
import type { CardCorners } from '../Card.h'

import { useEffect, useRef } from 'react'
import { VideoPosterSC } from './BaseCard.styled'

export const VideoPoster = ({
  videoUrl,
  posterHeight,
  posterWidth,
  playVideo,
  // borderRadius,
}: {
  videoUrl: string
  posterHeight?: number
  posterWidth?: number
  playVideo?: boolean
  borderRadius?: CardCorners
}): JSX.Element => {
  const videoREf = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoREf.current
    if (playVideo) {
      video?.play()
    } else {
      video?.pause()
    }
  }, [playVideo])
  const sourceType = videoUrl.includes('.mp4')
    ? 'mp4'
    : videoUrl.includes('.webm')
      ? 'webm'
      : 'ogv'
  return (
    <VideoPosterSC
      loop={true}
      muted={true}
      height={`${posterHeight}%`}
      width={`${posterWidth}%`}
      autoPlay={true}
      ref={videoREf}
      // borderRadius={borderRadius || CardCorners.CORNERS_0}
    >
      <source src={videoUrl} type={`video/${sourceType}`} />
    </VideoPosterSC>
  )
}
